// extracted by mini-css-extract-plugin
module.exports = {"loadingIndicator":"LoadingIndicator_loadingIndicator__PFvkP"};